define('view/controller/index/IndexView',['require','lib/view/LayoutView','Config','lib/theme/ThemeSettings'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var Config = require('Config');
    var ThemeSettings = require('lib/theme/ThemeSettings');
	
	/**
	 * Index page view
	 * 
	 * @class IndexView
	 */
	return LayoutView.extend({

		template: '#index_page',

		modelEvents: {
			'change': 'render'
		},
		ui: {
			map: '#sb_map'
		},
		_showOnMap: false,

		serializeData: function () {
			var result = LayoutView.prototype.serializeData.apply(this);
			result.current_url = location.href;
			result.map_key = Config.getInstance().getOption('map_api_key');
			//result.work_day_names = new Date().getWeekDaysList('medium');
			result.work_day_names = new Date().getWeekDaysList('long');
			result.about_us = this.getOption('showAboutUs');
            result.show_on_map = this.getOption('showOnMap');
            
            var mondayIsFirstDay = Config.isMondayFirstDay() === true || parseInt(Config.isMondayFirstDay());
            if (result.opening_hours_info) {
                result.opening_hours_info = _.sortBy(result.opening_hours_info, function (dayInfo) {
                    if (dayInfo.day_index == 7 && !mondayIsFirstDay) {
                        return 0;
                    } else {
                        return dayInfo.day_index;
                    }
                });
            }

			_.each(result.opening_hours_info, function (value, key) {
				value.day_name_short = result.work_day_names[key];
			});
            
            var contentGridSettings = ThemeSettings.getInstance().getOption('index_page_content_grid');
            result.contentGrid = contentGridSettings ? JSON.parse(contentGridSettings) : null;

			if(result.whatsapp){
				result.whatsapp_clean = result.whatsapp.replace(/\D/g, '');
			}
            
			return result;
		},

		onDomRefresh: function () {
			this.onShowPage();
		},

		onShowPage: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'index',
				'showOnMap': this.getOption('showOnMap'),
				'showAboutUs': this.getOption('showAboutUs')
			});
		}

	});
	
});
